export const GET_LIST_SHOWTIME_PAGE = 'GET_LIST_SHOWTIME_PAGE'
export const GET_CODE_CINEMA_PAGE = 'GET_CODE_CINEMA_PAGE'
export const GET_CODE_GROUP_CINEMA_PAGE = 'GET_CODE_GROUP_CINEMA_PAGE'
export const GET_NAME_GROUP_CINEMA_PAGE = 'GET_NAME_GROUP_CINEMA_PAGE'
export const GET_MOVIE_SCHEDULE_PAGE = "GET_MOVIE_SCHEDULE_PAGE"

export const SCHEDULE_TAB = "SCHEDULE_TAB"